import { render, staticRenderFns } from "./DocumentDefinitionsEdit.vue?vue&type=template&id=525c5750&scoped=true"
import script from "./DocumentDefinitionsEdit.vue?vue&type=script&lang=js"
export * from "./DocumentDefinitionsEdit.vue?vue&type=script&lang=js"
import style0 from "./DocumentDefinitionsEdit.vue?vue&type=style&index=0&id=525c5750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c5750",
  null
  
)

export default component.exports